import type { MouseEvent } from 'react'

/** True when a click landed on a control inside a row, so the row itself should not also open. */
export function isControlClick(event: MouseEvent<HTMLElement>): boolean {
  return (
    event.target instanceof Element && event.target.closest('button, a, [role="menu"]') !== null
  )
}
